import React from "react";
import PhoneMockup, {
  ScreenAuth,
  ScreenHome,
  ScreenCreateTournament,
  ScreenLiveScore,
  ScreenLeaderboard,
  ScreenPodium,
  ScreenRegularScore,
  ScreenPlayers,
  ScreenStats,
  RealScreenHome,
  RealScreenPodium,
  RealScreenSignIn,
} from "./PhoneMockup";

const screens = [
  { comp: <RealScreenSignIn />, label: "Sign in" },
  { comp: <RealScreenHome />, label: "Live tournament" },
  { comp: <RealScreenPodium />, label: "Podium & confetti" },
  { comp: <ScreenCreateTournament />, label: "Create" },
  { comp: <ScreenLiveScore />, label: "Live Score" },
  { comp: <ScreenLeaderboard />, label: "Leaderboard" },
  { comp: <ScreenRegularScore />, label: "Regular" },
  { comp: <ScreenPlayers />, label: "Players" },
  { comp: <ScreenStats />, label: "Stats" },
  { comp: <ScreenHome />, label: "Home mock" },
  { comp: <ScreenAuth />, label: "Sign in mock" },
];

export default function Screenshots() {
  return (
    <section
      id="screens"
      data-testid="screenshots-gallery"
      className="relative py-20 md:py-24 border-t border-neutral-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 mb-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div>
            <div className="text-xs uppercase tracking-widest text-[#D4F34A] mb-3">
              Inside the app
            </div>
            <h2
              data-testid="screenshots-heading"
              className="font-display uppercase tracking-tight text-5xl md:text-7xl leading-[0.9]"
            >
              Every screen,
              <br />
              built for the game.
            </h2>
          </div>
          <p className="text-neutral-400 max-w-sm text-sm md:text-base">
            Real screens from the app — from sign-in through podium — designed
            for the pace of live padel.
          </p>
        </div>
      </div>

      <div
        data-testid="screenshot-carousel"
        className="no-scrollbar overflow-x-auto"
      >
        <div className="flex gap-5 px-6 md:px-10 pb-6 min-w-max">
          {screens.map((s, i) => (
            <div
              key={i}
              data-testid={`screenshot-item-${i}`}
              className="flex-none flex flex-col items-center"
            >
              <div className="w-[220px] h-[460px] md:w-[240px] md:h-[500px]">
                <PhoneMockup>{s.comp}</PhoneMockup>
              </div>
              <div className="mt-4 text-[11px] uppercase tracking-widest text-neutral-500">
                <span className="text-[#D4F34A] mr-2 font-display">
                  0{i + 1}
                </span>
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-8">
        <div className="text-[11px] uppercase tracking-widest text-neutral-500 flex items-center gap-2">
          <span>← Scroll to explore</span>
          <div className="flex-1 h-px bg-neutral-900" />
          <span>{screens.length} screens</span>
        </div>
      </div>
    </section>
  );
}
